import React from "react";
import cart from "../../images/Cart.svg";
import { Link } from "react-router-dom";
import { useQuery } from "@apollo/react-hooks";
import { hasuraClient } from "../../apolloClient";
import { GET_ACTIVE_DEALS } from "../../query/getActiveDeals";
import moment from "moment";
const ActiveDeals = () => {
  const {
    data: activeDealsData,
    loading: activeDealsLoading,
    error: activeDealsError,
  } = useQuery(GET_ACTIVE_DEALS, {
    client: hasuraClient,
    fetchPolicy: "cache-and-network",
    variables: {
      business_profile_id: localStorage.getItem("profile_id"),
      club_profile_id: localStorage.getItem("profile_id"),
      current_date_time: moment().format(),
      limit: 4,
    },
  });

  return (
    <div className="lastsubscription">
      <div className="title">
        <h2>Active Deals</h2>
        {activeDealsData?.deals?.length ? (
          <Link to="/active-deals">view all</Link>
        ) : (
          ""
        )}
      </div>
      <ul className="lastsubscription-list">
        {!activeDealsLoading
          ? activeDealsError
            ? "some error occurred..."
            : activeDealsData?.deals?.length
            ? activeDealsData?.deals?.map((item, index) => (
                <li key={index}>
                  <div className="col-left">
                    <div className="icon">
                      <img src={cart} alt="cart" />
                    </div>
                    <div className="subscription-name">
                      <p> {item?.name} </p>
                      <label>
                        Created {moment(item?.created_at).startOf().fromNow()}
                      </label>
                    </div>
                  </div>
                  <div className="subscription-price">
                    <p>{item?.views_count ?? 0} views</p>
                  </div>
                </li>
              ))
            : "No Data Found..."
          : "Loading..."}
      </ul>
    </div>
  );
};
export default ActiveDeals;
